import React from 'react'
import clsx from 'clsx'

import styles from './styles.module.scss'
interface DividerProps {
  className?: string
}

const Divider = ({ className }: DividerProps) => {
  return <div className={clsx(styles.Divider, 'Divider', className)} />
}

export default Divider
